import { Col, Row } from 'react-bootstrap';
import PlanCard from '../../../components/PlanCard';
import {
  addOrRemoveDaysToGivenDate,
  addOrRemoveMonthsToGivenDate,
  addOrRemoveYearsToGivenDate,
  formatDate,
} from '../../../utils/utils';

const cardData = [
  {
    planName: 'Cash Balance Plan',
    planDate: `(As of ${formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -1)
    )})`,
    status: 'Active',
    vestingPercentage: 100,
    services: {
      hireDate: 'Nov 13, 1999',
      participationDate: 'Nov 1, 2013',
      totalVestingService: '21.083 years',
      creditedServices: '7.167 years',
    },

    keyDates: {
      fullyVestedDate: '-',
      earlyRetirementDate: `${formatDate(
        addOrRemoveMonthsToGivenDate(new Date(), 1)
      )}`,
      normalRetirementDate: `${formatDate(
        addOrRemoveYearsToGivenDate(new Date(), 15)
      )}`,
    },
  },

  {
    planName: 'Qualified Plan',
    planDate: `(As of ${formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -1)
    )})`,
    status: 'Active',
    vestingPercentage: 100,
    services: {
      hireDate: 'Nov 13, 1999',
      participationDate: 'Nov 1, 2013',
      totalVestingService: '21.083 years',
      creditedServices: '7.167 years',
    },

    keyDates: {
      fullyVestedDate: '-',
      earlyRetirementDate: `${formatDate(
        addOrRemoveMonthsToGivenDate(new Date(), 1)
      )}`,
      normalRetirementDate: `${formatDate(
        addOrRemoveYearsToGivenDate(new Date(), 15)
      )}`,
    },
  },

  {
    planName: 'Non-Qualified Plan',
    planDate: `(As of ${formatDate(
      addOrRemoveDaysToGivenDate(new Date(), -1)
    )})`,
    status: 'Active',
    vestingPercentage: 100,
    services: {
      hireDate: 'Nov 13, 1999',
      participationDate: 'Nov 1, 2013',
      totalVestingService: '21.083 years',
      creditedServices: '7.167 years',
    },

    keyDates: {
      fullyVestedDate: '-',
      earlyRetirementDate: `${formatDate(
        addOrRemoveMonthsToGivenDate(new Date(), 1)
      )}`,
      normalRetirementDate: `${formatDate(
        addOrRemoveYearsToGivenDate(new Date(), 15)
      )}`,
    },
  },
];

const Summary = () => {
  return (
    <Row className={'flex-column flex-lg-row pt-5 pt-lg-9 mt-lg-3'}>
      {cardData.map((data) => {
        return (
          <Col className={'mb-10 mb-lg-0'}>
            <PlanCard cardData={data} />
          </Col>
        );
      })}
    </Row>
  );
};

export default Summary;
